export default "__VITE_PUBLIC_ASSET__293ccbe6__"